import React, { Component } from 'react'

// Externals
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Typography, withStyles } from '@material-ui/core'
import { Money as MoneyIcon } from '@material-ui/icons'
import { Paper } from 'components'
import styles from './styles'

class Profit extends Component {
  render () {
    const { classes, className, amount, ...rest } = this.props

    const rootClassName = classNames(classes.root, className)

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Total Transactions
            </Typography>
            <Typography
              className={classes.value}
              variant='h3'
            >
              &#8377;{` ${amount}`}
            </Typography>
          </div>
          <div className={classes.iconWrapper}>
            <MoneyIcon className={classes.icon} />
          </div>
        </div>
      </Paper>
    )
  }
}

Profit.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Profit)
